import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';

const IncompatibleDevicesModal = function ({ showSignal, closeModal, deviceIncompatibilitySignal, utgIncompatibilitySignal, pciIncompatibilitySignal }) {
	return (
		<Modal
			show={showSignal.value}
			onHide={closeModal}
			>
			<Modal.Header closeButton>
				<Modal.Title>Incompatible Devices</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p id="message">{
					deviceIncompatibilitySignal.value ? (
						utgIncompatibilitySignal.value ? (
							pciIncompatibilitySignal.value ? (
								<>The selected devices have different reported device types and PCI versions. Furthermore, one or more of the selected devices has an incompatible UTG version. Please check that all selected devices have the same reported device type and PCI version, and are running UTG version 5.0.0.3018 or later in order to proceed.</>
							) : (
								<>The selected devices have different reported device types. Furthermore, one or more of the selected devices has an incompatible UTG version. Please check that all selected devices have the same reported device type and are running UTG version 5.0.0.3018 or later in order to proceed.</>
							)
						) : (
							pciIncompatibilitySignal.value ? (
								<>The selected devices have different reported device types and PCI versions. Please check that all selected devices have the same reported device type and PCI version to proceed.</>
							) : (
								<>The selected devices have different reported device types. Please check that all selected devices have the same reported device type to proceed.</>
							)
						)
					) : (
						utgIncompatibilitySignal.value ? (
							pciIncompatibilitySignal.value ? (
								<>The selected devices have different PCI versions. Furthermore, one or more of the selected devices has an incompatible UTG version. Please check that all selected devices have the same PCI version and are running UTG version 5.0.0.3018 or later in order to proceed.</>
							) : (
								<>One or more of the selected devices has an incompatible UTG version. Please check that all selected devices are running UTG version 5.0.0.3018 or later in order to proceed.</>
							)
						) : (
							pciIncompatibilitySignal.value ? (
								<>The selected devices have different PCI versions. Please check that only devices with the same PCI version are selected in order to proceed.</>
							) : (
								<>Error: This element should only be rendered when the selected devices are incompatible, but no incompatibilty was detected.</>
							) 
						)
					)
				}</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={closeModal}>Close</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default IncompatibleDevicesModal